/** 件数上限つきの LRU（sandboxd-client.md §4.5）。 */
export class LruCache<V> {
  readonly #max: number;
  readonly #map = new Map<string, V>();

  constructor(max: number) {
    this.#max = Math.max(0, max);
  }

  get size(): number {
    return this.#map.size;
  }

  get(key: string): V | undefined {
    if (!this.#map.has(key)) return undefined;
    const v = this.#map.get(key);
    if (v === undefined) return undefined;
    this.#map.delete(key);
    this.#map.set(key, v);
    return v;
  }

  set(key: string, value: V): void {
    this.#map.delete(key);
    this.#map.set(key, value);
    while (this.#map.size > this.#max) {
      const oldest = this.#map.keys().next();
      if (oldest.done) break;
      this.#map.delete(oldest.value);
    }
  }

  clear(): void {
    this.#map.clear();
  }
}
